export const cleanBody = (obj: Record<any, any>) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== null &&
        value !== '' &&
        value !== undefined &&
        !(typeof value === 'number' && isNaN(value)),
    ),
  );
